import { ProductDetails } from "@/@types";
import { ApiClient } from "../../ApiClient"
import { GetProductDetailsResponse } from "../schema/GetProductDetailsResponse";
import { mapProductDetails } from "../../mappers/productDetailsMapper";

export const getProductDetails = async (productSlug: string): Promise<ProductDetails> => {

    const client = ApiClient.getInstance()
    const response = await client.get<GetProductDetailsResponse>(`products/details/${productSlug}`)

    return mapProductDetails(response.product);
}